<template>
  <v-footer color="secondary" class="mt-6">
    <v-container>
      <v-row>
        <v-col>
          <v-row align="center" justify="center">
            <img src="../assets/downloadApp.png" class="ml-2 image" />
          </v-row>
        </v-col>
        <v-col class="text-center">
          <v-row align="center" justify="center" class="mr-4">
            <p class="descuento">$100 descuento</p>
          </v-row>
          <v-row align="center" justify="center" class="mr-4">
            <p class="servicio">en tu primer servicio</p>
          </v-row>
          <v-row align="center" justify="center" class="mr-4">
            <v-btn dark @click="downloadApp()">Descarga la app</v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
var mixpanel = require('mixpanel-browser');
import config from "../config"
mixpanel.init(config.key);

export default {
  methods: {
    downloadApp() {
      mixpanel.track('Click descarga app body');
      window.location = "http://okboy.app.link/ZRYV3YJZefb";
    },
  },
};
</script>

<style scoped>
.descuento {
  font-size: 24px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.01px;
  color: #303034;
  letter-spacing: -0.02px;
}
.servicio {
  font-size: 16px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.01px;
  color: #303034;
}
.image {
  width: 180px;
  height: 200px;
  object-fit: contain;
}
</style>